/* src/app/cost-estimator/cost-estimator.component.scss */
.flex-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.fill-height,
.white-content-page,
.white-sheet-content {
  flex: 1 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  align-content: stretch;
}
.page-center,
.white-content-page .ups-content-block,
.white-content-page .ups-page-header,
.white-sheet-content {
  min-width: 21.5rem;
  max-width: 71.875rem;
  width: 100%;
  margin: 0 auto;
}
.white-sheet-content {
  background-color: white;
}
.white-sheet-content .ups-page-header {
  padding: 1.125rem 23px;
}
@media screen and (min-width: 48rem) {
  .white-sheet-content .ups-page-header {
    padding: 2.625rem 2rem;
  }
}
.white-content-page {
  background-color: white;
  min-height: 100%;
}
.white-content-page .ups-page-header {
  padding-bottom: 1em;
  min-width: auto;
}
.white-content-page .ups-content-block {
  padding: 0 2rem 2em;
}
.cost-estimator {
  font-size: 1rem;
}
.cost-estimator .mat-mdc-dialog-content {
  padding-bottom: 1em;
}
.cost-estimator .ups-form .form-section-header .form-section-title {
  font-size: 1.125em;
}
.cost-estimator .ups-form .form-body .form-sections {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .ups-form .form-body .form-sections {
    flex-direction: row;
    justify-content: space-between;
  }
}
@media screen and (min-width: 48rem) {
  .cost-estimator .ups-form .form-body .form-sections > .info,
  .cost-estimator .ups-form .form-body .form-sections > .options {
    width: 50%;
  }
}
@media screen and (min-width: 48rem) {
  .cost-estimator .ups-form .form-body .form-sections > .info {
    padding-right: 2em;
  }
}
@media screen and (min-width: 64rem) {
  .cost-estimator .ups-form .form-body .form-sections > .options {
    padding-left: 2em;
  }
}
.cost-estimator .ups-form .form-body .form-sections .form-section {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  margin-bottom: 0.625rem;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .ups-form .form-body .form-sections .form-section {
    margin-top: 0;
  }
}
.cost-estimator .ups-form .form-body .form-sections .form-section .form-section-header {
  margin-bottom: 0;
}
.cost-estimator .ups-form .form-footer .form-actions {
  flex-wrap: nowrap;
}
.cost-estimator .disclaimer {
  margin-top: 0.625rem;
  font-size: 0.625rem;
  color: rgba(110, 110, 110, 0.87);
}
@media screen and (min-width: 48rem) {
  .cost-estimator .disclaimer {
    font-size: 0.9em;
  }
}
.cost-estimator .custom-packaging {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
}
.cost-estimator .custom-packaging .mat-mdc-form-field {
  width: 23%;
  margin-right: 1em;
}
.cost-estimator .custom-packaging-note {
  font-size: 0.9em;
}
.cost-estimator .shipping-options .shipping-options-header {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  width: 95%;
}
.cost-estimator .shipping-options .shipping-options-header .carrier-icon {
  margin-right: 1em;
}
.cost-estimator .shipping-options .shipping-options-header .carrier-icon.summary {
  max-width: 1.875rem;
}
.cost-estimator .shipping-options .shipping-options-header .shipping-options-title {
  font-weight: 700;
  margin: 0;
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate {
  font-size: 0.9rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  flex-grow: 1;
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
  line-height: 1.5;
  padding-right: 1em;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details {
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    width: 60%;
  }
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .title {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .title {
    width: 40%;
  }
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .title .service-name {
  font-size: 0.9em;
  font-weight: 700;
  margin: 0 0 0.2em 0;
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .title .transit-days {
  font-size: 0.75em;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .title .transit-days {
    font-size: 0.85em;
  }
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs {
  font-size: 0.575em;
  color: #707070;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs {
    text-align: center;
  }
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs {
    font-size: 0.8em;
  }
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs {
    width: 65%;
  }
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs .accessorial-fee {
    display: block;
  }
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs .accessorial-cost {
  display: none;
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .details .costs .shipping-cost {
  display: none;
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .summary {
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .summary {
    width: 40%;
  }
}
.cost-estimator .shipping-options .shipping-options-header .ship-service-estimate .summary .total {
  font-size: 1.25rem;
  font-weight: 700;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}
.cost-estimator .shipping-options ul.services {
  margin: 0;
  padding: 0;
  list-style-type: none;
}
.cost-estimator .shipping-options ul.services li.service {
  margin: 0 -24px;
}
.cost-estimator .shipping-options ul.services li.service > label {
  padding: 1.1435em 1em;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-start;
  font-weight: initial;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options ul.services li.service > label {
    padding: 1.1435em 24px;
  }
}
.cost-estimator .shipping-options ul.services li.service > label:hover {
  background-color: #f4f4f4;
  cursor: pointer;
}
.cost-estimator .shipping-options ul.services li.service > label .mat-mdc-radio-button {
  margin-right: 0.5em;
}
@media screen and (min-width: 48rem) {
  .cost-estimator .shipping-options ul.services li.service > label .mat-mdc-radio-button {
    display: none;
  }
}
.cost-estimator button.ship-now {
  width: 100%;
  display: block;
}
@media screen and (min-width: 48rem) {
  .cost-estimator button.ship-now {
    display: none;
  }
}
.cost-estimator .mat-expansion-panel {
  margin-bottom: 0.625rem;
}
.cost-estimator .mat-mdc-radio-group {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  justify-content: flex-start;
}
::ng-deep .mat-expansion-panel {
  border-radius: 5px;
  box-shadow: 0 1px 2px 0 rgba(217, 217, 214, 0.5) !important;
  background-color: #ffffff;
  border: solid 1px #d9d9d6;
}
::ng-deep .mat-expansion-panel .mat-expansion-panel-header {
  min-height: 80px !important;
  height: 80px !important;
  padding: 0 1rem;
}
::ng-deep .mat-expansion-panel .mat-expansion-panel-header.blur {
  opacity: 0.5;
}
::ng-deep .mat-expansion-panel .mat-expansion-panel-header .mat-expansion-panel-header-title {
  margin-right: 0;
}
::ng-deep .cod {
  margin-bottom: 1em;
}
::ng-deep .cod input {
  margin-top: 1em;
  font-size: 0.9em;
  width: 8em;
  margin-left: 1.5em;
  border-bottom: 1px solid #d9d9d6;
}
::ng-deep .cod .mat-mdc-checkbox {
  margin-left: 1.8em;
}
/*# sourceMappingURL=cost-estimator.component.css.map */
